import { QuestionnaireFlowQuestionOption } from "@/types/question.types";
import { Stack, Textarea, useMantineTheme } from "@mantine/core";
import { AnswerOptionButton } from "./AnswerOptionButton";

type AnswerOptionsListProps = {
  options: QuestionnaireFlowQuestionOption[];
  questionType: "select_multiple" | "select_single";
  selectedOptions?: number[] | string;
  onSelectMultiple: (option: QuestionnaireFlowQuestionOption) => void;
  onSelectSingle: (option: QuestionnaireFlowQuestionOption) => void;
  customInputValue?: string;
  onCustomInputChange?: (value: string) => void;
};

export function AnswerOptionsList({
  options,
  questionType,
  selectedOptions,
  onSelectMultiple,
  onSelectSingle,
  customInputValue,
  onCustomInputChange,
}: AnswerOptionsListProps) {
  const theme = useMantineTheme();

  const isOptionSelected = (option: QuestionnaireFlowQuestionOption) => {
    // category is "custom" e.g. dynamic personality test questions
    if (Array.isArray(selectedOptions) && option.id) {
      return selectedOptions.includes(option.id);
    }
    // all other categories e.g. hardcoded identity questions
    if (typeof selectedOptions === "string") {
      return selectedOptions === option.value;
    }
    return false;
  };

  return (
    <>
      {options?.map((option) => {
        const isSelected = isOptionSelected(option);
        return (
          <Stack key={option.id} w="100%" gap="xs">
            <AnswerOptionButton
              displayText={option.displayText}
              isSelected={isSelected}
              onClick={() => {
                if (questionType === "select_multiple") {
                  onSelectMultiple(option);
                } else if (questionType === "select_single") {
                  onSelectSingle(option);
                }
              }}
            />
            {option.customInputType === "text_input" && isSelected && (
              <Textarea
                placeholder="입력"
                value={customInputValue || ""}
                onChange={(e) => onCustomInputChange?.(e.currentTarget.value)}
                styles={{
                  input: {
                    backgroundColor: theme.black,
                    color: theme.white,
                  },
                }}
              />
            )}
          </Stack>
        );
      })}
    </>
  );
}
